import { type MenuItem } from '@direct-frontend/components';
import { type MenuItemProps } from '#shared/lib/integrations';
import { getIconByIntegrationType } from './getIconByIntegrationType';
import { type AvailableSource as AvailableIntegrationSource, getIntegrationSourceData } from './integrationSourceData';

export const createSourceMenuItem = ({
    type,
    handleChangeSource,
    isDisabledMenuItemForChoose,
    isDisabled,
    help,
}: MenuItemProps) => {
    if (isDisabledMenuItemForChoose) {
        return null;
    }

    const { Icon } = getIconByIntegrationType(type);

    const menuItem: MenuItem | null = {
        value: type,
        addonRight: Icon ? <Icon size="24" /> : undefined,
        content: getIntegrationSourceData(type as AvailableIntegrationSource).displayName,
        onAction: () => handleChangeSource(type),
        disabled: isDisabled ?? false,
        help,
    };

    return menuItem;
};
